/**
 * Minimal i18n utility with English defaults and German translations.
 * Detects locale from document language or browser language.
 */

const translations = {
	en: {
		settings: {
			title: "Text-to-Speech Settings",
			speed: "Speed:",
			speedValueSuffix: "x",
			pitch: "Pitch:",
			banner: "Show text banner",
			highlight: "Highlight text",
			shortcuts: {
				title: "Keyboard Shortcuts:",
				playPause: "Play/Pause",
				next: "Next",
				previous: "Previous",
			},
		},
		player: {
			buttons: {
				previous: "Previous (Alt+Z)",
				play: "Play (Alt+P)",
				pause: "Pause (Alt+P)",
				next: "Next (Alt+V)",
				settings: "Settings",
				close: "Close",
			},
		},
	},
	de: {
		settings: {
			title: "Vorlese-Einstellungen",
			speed: "Geschwindigkeit:",
			speedValueSuffix: "x",
			pitch: "Tonhöhe:",
			banner: "Textbanner anzeigen",
			highlight: "Text hervorheben",
			shortcuts: {
				title: "Tastenkürzel:",
				playPause: "Abspielen/Pause",
				next: "Weiter",
				previous: "Zurück",
			},
		},
		player: {
			buttons: {
				previous: "Zurück (Alt+Z)",
				play: "Abspielen (Alt+P)",
				pause: "Pause (Alt+P)",
				next: "Weiter (Alt+V)",
				settings: "Einstellungen",
				close: "Schließen",
			},
		},
	},
};

function detectLocale() {
	const docLang = (document?.documentElement?.lang || "").toLowerCase();
	if (docLang.startsWith("de")) return "de";
	const navLang = (
		navigator?.language ||
		navigator?.userLanguage ||
		""
	).toLowerCase();
	if (navLang.startsWith("de")) return "de";
	return "en";
}

const locale = detectLocale();

function get(obj, path) {
	return path
		.split(".")
		.reduce(
			(acc, key) =>
				acc && acc[key] !== undefined ? acc[key] : undefined,
			obj,
		);
}

export function t(key) {
	const deValue = get(translations[locale], key);
	if (deValue !== undefined) return deValue;
	const enValue = get(translations.en, key);
	return enValue !== undefined ? enValue : key;
}

export default { t };
